import { TemplatePage } from './types';

const countdownPage: TemplatePage = {
  header: {
    color: '#FDF5E0',
    icon: 'images/video-templates/countdown.jpg',
    title: 'Countdown Timer Video Templates',
    title_meta: 'Free Countdown Timer Video Templates',
    description_meta:
      'Build anticipation and suspense for your live stream with Wave.video’s collection of 20+ customizable countdown ' +
      'timer video templates.',
    description:
      'Build anticipation and suspense for your live stream with Wave.video’s collection of customizable countdown timer ' +
      'video templates. Easily personalize and download a countdown template of your choice to use in your next live video.'
  },
  footer: {
    category: 'Countdown',
    description:
      'With Wave.video’s impressive collection of easy-to-edit countdown timer video templates, you will be able to give ' +
      'your video content a polished, professional look without having any prior video editing experience. ' +
      'Make awe-inspiring videos for your live stream, website, blog, and social media in a matter of minutes.'
  },
  content: [
    {
      type: 'templates',
      title: 'Countdown video templates',
      search: { category: '/Use Cases/Countdown' }
    },
    {
      type: 'stocks',
      title: 'countdown',
      search: { name: 'countdown' }
    },
    { type: 'calendar' }
  ]
};

export default countdownPage;
